// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, createOrUpdate, $delete, get } from "./operations.js";
export type {
  EvaluationRulesListOptionalParams,
  EvaluationRulesCreateOrUpdateOptionalParams,
  EvaluationRulesDeleteOptionalParams,
  EvaluationRulesGetOptionalParams,
} from "./options.js";
